"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcBreadcrumbV2Behavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var bc_float_menu_behavior_1 = require("../bc-float-menu/bc-float-menu-behavior");
var bc_breadcrumb_v2_constants_1 = require("./bc-breadcrumb-v2-constants");
var bc_breadcrumb_v2_float_menu_behavior_1 = require("./bc-breadcrumb-v2-float-menu-behavior");
var BcBreadcrumbV2Behavior = (function (_super) {
    __extends(BcBreadcrumbV2Behavior, _super);
    function BcBreadcrumbV2Behavior() {
        var _this = _super.call(this) || this;
        _this.toggle = false;
        _this.allowFloatmenuUrlListeners = true;
        return _this;
    }
    BcBreadcrumbV2Behavior.prototype._setUp = function () {
        var _this = this;
        this._setWindowEvents();
        this._listenForAttributeChanges();
        this._updateBreadcrumbItems();
        this.breadcrumbList = this.mySelf.querySelector(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEMS));
        this._initWindowState();
        this._setFloatmenu();
        setTimeout(function () {
            _this._validateOverflowText();
        }, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_REDRAW_TIMER);
    };
    BcBreadcrumbV2Behavior.prototype.redrawBreadcrumb = function () {
        var _this = this;
        this._updateBreadcrumbItems();
        this.breadcrumbList = this.mySelf.querySelector(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEMS));
        this._initWindowState();
        this._setFloatmenu();
        setTimeout(function () {
            _this._validateOverflowText();
        }, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_REDRAW_TIMER);
    };
    BcBreadcrumbV2Behavior.prototype._setFloatmenu = function () {
        var breadcrumbElement = this.getMySelf();
        var floatmenuElement = breadcrumbElement.querySelector(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_FLOAT_MENU));
        if (floatmenuElement) {
            var bcFloatmenuBehavior = new bc_float_menu_behavior_1.BcFloatMenuBehavior();
            bcFloatmenuBehavior.setElement(floatmenuElement);
            bcFloatmenuBehavior.setUp();
        }
    };
    BcBreadcrumbV2Behavior.prototype._setWindowEvents = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            if (_this.toggle != _this._isMobile()) {
                _this.mySelf.querySelector('ol').remove();
                _this.redrawBreadcrumb();
            }
            _this.toggle = _this._isMobile();
        });
    };
    BcBreadcrumbV2Behavior.prototype._listenForAttributeChanges = function () {
        var _this = this;
        var attributesToObserve = [bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.Bc_BREADCRUMB_V2_DATA_ATTRIBUTE];
        var config = { attributeFilter: attributesToObserve };
        var callback = function (mutationList, _) {
            for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                var mutation = mutationList_1[_i];
                if (mutation.attributeName == bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.Bc_BREADCRUMB_V2_DATA_ATTRIBUTE) {
                    var itemsString = _this.getMySelf().getAttribute(mutation.attributeName);
                    _this.breadcrumbItems = _this._parseListAttribute(itemsString);
                    _this.redrawBreadcrumb();
                }
            }
        };
        var observer = new MutationObserver(callback);
        observer.observe(this.mySelf, config);
    };
    BcBreadcrumbV2Behavior.prototype._parseListAttribute = function (jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch (error) {
            return [];
        }
    };
    BcBreadcrumbV2Behavior.prototype._updateBreadcrumbItems = function () {
        var _this = this;
        var _a;
        (_a = this.getMySelf().querySelector(common_constants_1.BcCommonConstants.OL_TAG)) === null || _a === void 0 ? void 0 : _a.remove();
        var olElement = document.createElement(common_constants_1.BcCommonConstants.OL_TAG);
        olElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEMS);
        this.breadcrumbItems.forEach(function (item, index) {
            var liElement = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
            liElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM);
            if (index !== _this.breadcrumbItems.length - 1) {
                var aElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
                aElement.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_BC_LINK, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_LINK_DEFAULT);
                aElement.setAttribute(common_constants_1.BcCommonConstants.ATTR_HREF, item.url);
                var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
                spanElement.textContent = item.name;
                aElement.appendChild(spanElement);
                liElement.appendChild(aElement);
            }
            else {
                var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
                spanElement.textContent = item.name;
                liElement.appendChild(spanElement);
            }
            olElement.appendChild(liElement);
        });
        this.getMySelf().appendChild(olElement);
    };
    BcBreadcrumbV2Behavior.prototype._updateBreadcrumb = function (startIndex) {
        var breadcrumbItems = Array.from(this.breadcrumbList.getElementsByClassName(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM));
        this.breadCrumbItemsList = breadcrumbItems;
        for (var i = startIndex; i < breadcrumbItems.length; i++) {
            this.breadcrumbList.appendChild(breadcrumbItems[i]);
        }
        this._validateMinimumItems();
    };
    BcBreadcrumbV2Behavior.prototype._validateMinimumItems = function () {
        var hideElement = this.breadcrumbList;
        if (this.breadcrumbList.childElementCount < common_constants_1.COMMON_CONSTANTS_NUMBERS.N2) {
            hideElement.style.display = common_constants_1.BcCommonConstants.NONE;
        }
        else {
            hideElement.style.display = common_constants_1.BcCommonConstants.FLEX;
        }
    };
    BcBreadcrumbV2Behavior.prototype._updateFloatMenu = function () {
        this._clearFloatMenu();
        this._generateFloatMenuItems();
        if (this.breadCrumbItemsListFloatMenu.length > 0) {
            var bcBreadcrumbV2FloatMenu = new bc_breadcrumb_v2_float_menu_behavior_1.BcBreadcrumbV2FloatMenu(this.breadCrumbItemsListFloatMenu, this.mobileOption);
            var floatMenuItem = bcBreadcrumbV2FloatMenu.generateFloatMenu();
            this.breadcrumbList.insertBefore(floatMenuItem, this.breadcrumbList.firstChild);
            this._floatMenuClickADetection();
        }
        this._addSeparationArrows();
    };
    BcBreadcrumbV2Behavior.prototype._generateFloatMenuItems = function () {
        for (var i = 0; i < this.breadCrumbItemsList.length - this.mobileOption; i++) {
            this._removeAccessibility(this.breadCrumbItemsList[i]);
            this.breadCrumbItemsListFloatMenu.push(this.breadCrumbItemsList[i]);
        }
    };
    BcBreadcrumbV2Behavior.prototype._clearFloatMenu = function () {
        this.breadCrumbItemsListFloatMenu = [];
    };
    BcBreadcrumbV2Behavior.prototype._removeAccessibility = function (element) {
        var ref = element.querySelector(common_constants_1.BcCommonConstants.HREF_TAG);
        if (ref) {
            ref.tabIndex = -1;
        }
    };
    BcBreadcrumbV2Behavior.prototype._calcElementWidth = function (element) {
        return element.clientWidth;
    };
    BcBreadcrumbV2Behavior.prototype._validateOverflowText = function () {
        var _this = this;
        var arrayBreadcrumbItem = this.mySelf.querySelectorAll(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM));
        var lastItemIndex = arrayBreadcrumbItem.length - 1;
        var breadCrumbElement = this.mySelf;
        arrayBreadcrumbItem.forEach(function (item, index) {
            var link = item.querySelector(common_constants_1.BcCommonConstants.HREF_TAG);
            var span = item.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            var contentLink = span.textContent;
            var elementWidth = _this._calcElementWidth(span);
            if (elementWidth > bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_SPAN_WIDTH) {
                span === null || span === void 0 ? void 0 : span.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_CLASS);
                link === null || link === void 0 ? void 0 : link.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP);
                link === null || link === void 0 ? void 0 : link.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP, common_constants_1.BcCommonConstants.TRUE.toString());
                link === null || link === void 0 ? void 0 : link.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_TEXT_ATTRIBUTE, contentLink);
                link === null || link === void 0 ? void 0 : link.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION_ATTRIBUTE, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION);
                if (index == lastItemIndex) {
                    _this._setSpanTooltip(span, contentLink);
                }
            }
        });
        var tooltipElements = Array.from(breadCrumbElement.querySelectorAll(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP)));
        tooltipElements.forEach(function (element) {
            var bcTooltipBehavior = new bc_tooltip_behavior_1.BcTooltipBehavior();
            bcTooltipBehavior.setElement(element);
            bcTooltipBehavior.setUp();
        });
    };
    BcBreadcrumbV2Behavior.prototype._setSpanTooltip = function (span, contentLink) {
        span.classList.add(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP);
        span.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP, common_constants_1.BcCommonConstants.TRUE.toString());
        span.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_TEXT_ATTRIBUTE, contentLink);
        span.setAttribute(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION_ATTRIBUTE, bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOOLTIP_POSITION);
    };
    BcBreadcrumbV2Behavior.prototype._floatMenuClickADetection = function () {
        var _this = this;
        var floatMenuOptions = this.mySelf.querySelectorAll(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_OPTIONS));
        floatMenuOptions.forEach(function (options) {
            options.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this._triggerRedirection(options);
            });
            options.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    _this._triggerRedirection(options);
                }
            });
        });
    };
    BcBreadcrumbV2Behavior.prototype._triggerRedirection = function (option) {
        var link = option.querySelector(common_constants_1.BcCommonConstants.HREF_TAG);
        var href = link.getAttribute(common_constants_1.BcCommonConstants.ATTR_HREF);
        if (href && this.allowFloatmenuUrlListeners) {
            window.location.href = href;
        }
    };
    BcBreadcrumbV2Behavior.prototype._addSeparationArrows = function () {
        var breadcrumbLists = this.mySelf.querySelector(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEMS));
        var breadcrumbItem = breadcrumbLists.querySelectorAll(".".concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ITEM, ":not(.").concat(bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_FLOAT_MENU_OPTIONS, ")"));
        var initializer = this.breadCrumbItemsListFloatMenu.length > 0 ? 0 : 1;
        for (var index = initializer; index < breadcrumbItem.length; index++) {
            var arrowSeparator = this._createArrowSeparator();
            breadcrumbItem[index].prepend(arrowSeparator);
        }
    };
    BcBreadcrumbV2Behavior.prototype._createArrowSeparator = function () {
        var emElement = document.createElement('em');
        emElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XS_CLASS);
        emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, common_constants_1.BcCommonConstants.TRUE.toString());
        emElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.IMG_TAG);
        emElement.textContent = bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_ANGLE_RIGHT_ICON;
        return emElement;
    };
    BcBreadcrumbV2Behavior.prototype._isMobile = function () {
        return window.outerWidth <= bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_MOBILE_WIDTH;
    };
    BcBreadcrumbV2Behavior.prototype._initWindowState = function () {
        this._clearMaximumBreadcrumbItems();
        this.mobileOption = this._isMobile() ? 1 : common_constants_1.COMMON_CONSTANTS_NUMBERS.N3;
        if (this.breadcrumbList) {
            this._updateBreadcrumb(this.breadcrumbList.childElementCount > this.mobileOption
                ? this.breadcrumbList.childElementCount - this.mobileOption
                : 0);
        }
        this._updateFloatMenu();
    };
    BcBreadcrumbV2Behavior.prototype._clearMaximumBreadcrumbItems = function () {
        if (this.breadcrumbList.childElementCount > common_constants_1.COMMON_CONSTANTS_NUMBERS.N6) {
            var listItems = this.breadcrumbList.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG);
            for (var i = 0; i < listItems.length - bc_breadcrumb_v2_constants_1.BcBreadcrumbV2Constants.BC_BREADCRUMB_V2_TOTAL_ITEMS; i++) {
                listItems[i].remove();
            }
        }
    };
    return BcBreadcrumbV2Behavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcBreadcrumbV2Behavior = BcBreadcrumbV2Behavior;
